import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { sendMagicLink } from '../lib/auth';

interface FormValues {
  email: string;
}

export default function Login() {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<FormValues>();

  async function onSubmit(values: FormValues) {
    setError(null);
    const email = values.email.trim().toLowerCase();
    try {
      await sendMagicLink(email);
      navigate(`/login/sent?email=${encodeURIComponent(email)}`);
    } catch (e) {
      setError(
        e instanceof Error ? e.message : 'Något gick fel. Försök igen.',
      );
    }
  }

  return (
    <div className="max-w-md mx-auto mt-16 bg-white rounded-lg shadow p-6">
      <h1 className="text-2xl font-bold mb-4 text-navy">Logga in</h1>
      <p className="mb-4 text-sm">
        Vi skickar en länk till din e-post. Klicka på länken för att logga in.
      </p>
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
        <label className="block">
          <span className="text-sm font-medium">E-post</span>
          <input
            type="email"
            inputMode="email"
            autoComplete="email"
            className="mt-1 block w-full rounded border-gray-300 shadow-sm focus:border-sky focus:ring-sky"
            {...register('email', {
              required: 'E-post krävs',
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: 'Ogiltig e-postadress',
              },
            })}
          />
          {errors.email && (
            <span className="text-bad text-sm">{errors.email.message}</span>
          )}
        </label>
        {error && <p className="text-bad text-sm">{error}</p>}
        <button
          type="submit"
          disabled={isSubmitting}
          className="w-full bg-sky text-white rounded px-4 py-2 font-medium disabled:opacity-50"
        >
          {isSubmitting ? 'Skickar…' : 'Skicka inloggningslänk'}
        </button>
      </form>
    </div>
  );
}
